(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("inputmask"), require("bootstrap-slider"), require("sortablejs"), require("nouislider"));
	else if(typeof define === 'function' && define.amd)
		define("surveyjs-widgets", ["inputmask", "bootstrap-slider", "sortablejs", "nouislider"], factory);
	else if(typeof exports === 'object')
		exports["surveyjs-widgets"] = factory(require("inputmask"), require("bootstrap-slider"), require("sortablejs"), require("nouislider"));
	else
		root["surveyjs-widgets"] = factory(root["Inputmask"], root["Slider"], root["Sortable"], root["noUiSlider"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__98__, __WEBPACK_EXTERNAL_MODULE__625__, __WEBPACK_EXTERNAL_MODULE__387__, __WEBPACK_EXTERNAL_MODULE__310__) => {
return 